export type BillingSummary = {
  amountDue: number
  currency: string
  periodEnd: Date
  periodStart: Date
  subscriptionId: string
  usage: number
  taxPercent: number
  createdAt: Date
}

// Empty billing summary (was the Immutable CampaignBillingSummaryRecord default).
const emptyBillingSummary = (): BillingSummary => ({
  amountDue: 0,
  currency: '',
  periodEnd: new Date(),
  periodStart: new Date(),
  subscriptionId: '',
  usage: 0,
  taxPercent: 0,
  createdAt: new Date(),
})

// Stripe invoice/subscription → the billing summary; derived: usage = sum of line quantities, unix seconds → Date, currency upper-cased.
export const billingSummaryFromServer = (x?: any): BillingSummary =>
  x
    ? {
        amountDue: x.invoice.total,
        periodEnd: new Date(x.invoice.period_end * 1000),
        periodStart: new Date(x.invoice.period_start * 1000),
        currency: x.invoice.currency.toUpperCase(),
        subscriptionId: x.subscription.id,
        usage: x.invoice.lines.data.reduce((acc, { quantity }) => acc + quantity, 0),
        taxPercent: x.subscription.tax_percent,
        createdAt: new Date(x.subscription.created * 1000),
      }
    : emptyBillingSummary()
